export const ArrowUpLeft = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 22V7H22" stroke="currentColor" stroke-width="2"/>
<path d="M25.3062 25.3062L7 7" stroke="currentColor" stroke-width="2"/>
</svg>`;
